import { memo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import HeaderLeftBorder, { HEADER_LEFT_BORDER_WIDTH } from './HeaderLeftBorder';
import ResizeAffordance, { getResizeAffordanceWidth } from './ResizeAffordance';
import { ContextMenuTriggerButton } from '../../contextMenu/context/ContextMenuHandlerContext';
import { useTrellisTheme } from '../../utils/useTrellisTheme';

/**
 * Shared component for column headers with and without DnD.
 * It lays out the column header to compensate the space when DnD'ing a column.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function ContentComponentInner({
  arrowsNode,
  children,
  columnName,
  columnNamespace,
  draggedLeft,
  draggedRight,
  dragHandle,
  isDragging,
  isLastColumn,
  onClick,
  onMouseDown,
  resizable
}) {
  const theme = useTrellisTheme();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeaderLeftBorder, {
      shouldHighlight: Boolean(!isDragging && draggedLeft)
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      inlineSize: `calc(100% - ${HEADER_LEFT_BORDER_WIDTH}px)`,
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(Flex, {
        paddingInline: "200",
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: "5px",
        children: dragHandle
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        overflow: "hidden",
        flexGrow: 1,
        flexShrink: 1,
        inlineSize: `calc(100% - ${getResizeAffordanceWidth(theme)})`,
        children: children
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        marginInlineStart: "auto",
        paddingInlineEnd: resizable ? undefined : '200',
        gap: "200",
        flexShrink: 0,
        flexGrow: 0,
        children: [/*#__PURE__*/_jsx(View, {
          paddingBlockStart: "100",
          children: arrowsNode
        }), /*#__PURE__*/_jsx(ContextMenuTriggerButton, {
          columnNamespace: columnNamespace,
          columnName: columnName
        })]
      }), resizable && /*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        flexGrow: 0,
        flexBasis: theme.space[250],
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(ResizeAffordance, {
          "data-test-id": `resize-header-${columnNamespace}-${columnName}`,
          onClick: onClick,
          onMouseDown: onMouseDown,
          $shouldHighlight: Boolean(!isDragging && draggedRight),
          $shouldOffsetRight: !isLastColumn,
          $theme: theme
        })
      })]
    })]
  });
}
export default /*#__PURE__*/memo(ContentComponentInner);